import { createReducer, on } from '@ngrx/store';
import { validateDeepLinkParams } from '../../adapters/query-params/query-params.adapter';
import {
  QueryParams,
  QueryParamsState
} from '../../models/states/query-params-state.interfaces';
import * as fromQueryParamsActions from '../actions/query-params.actions';
export const QueryParamsStateKey = 'queryPrams';

const initialState: QueryParamsState = {
  queryParams: null,
  hasDeepLinkingParams: false
};

export const queryParamsReducer = createReducer(
  initialState,
  on(
    fromQueryParamsActions.StoreQueryParamsInputValues,
    (state, { queryParams }) => {
      let deepLinkParams: QueryParams | null = null;
      let hasDeepLinkingParams = false;

      if (queryParams && Object.keys(queryParams).length) {
        deepLinkParams = validateDeepLinkParams(queryParams);

        hasDeepLinkingParams = Object.values(deepLinkParams).some(
          (value) => !!value
        );
      }

      return {
        ...state,
        queryParams: hasDeepLinkingParams ? deepLinkParams : null,
        hasDeepLinkingParams
      };
    }
  )
);
